import { jsx as m } from "react/jsx-runtime";
import "../../base-BUIxijjU.js";
import "react";
import { cssX as e } from "../../core/utils/css.js";
import { c as p } from "../../index-C7ezJk5b.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const x = ({
  style: o,
  className: r,
  testId: t,
  children: s = "Nothing found. Try searching something else.",
  ...i
}) => /* @__PURE__ */ m(
  "div",
  {
    style: o,
    "data-testid": t,
    className: p(
      e("SearchBox__no-results"),
      r
    ),
    ...i,
    children: s
  }
);
export {
  x as SearchBoxNoResults
};
